  import React, { useState, useEffect, useRef } from "react";

  import { createPortal } from "react-dom";

  import {
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
  } from "@mui/material";
  import CloseIcon from "@mui/icons-material/Close";

  import { useNavigate } from "react-router-dom";
  import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
  import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

  import NoImage from "../../images/resources/noImage.jpg";

  import { postPlaceBid } from "../../Model/Auction";

  import { getUser } from "../../Model/LocalStorage";

  import { getToken } from "../../Model/User";

  import WITHDRAWN_IMAGE from "../../../images/Banner/withdrawn.jpg";

  import { getProfile, JoinAuction } from "../../../Model/User";

  import ArtworkStage from "./components/ArtworkStage";

  import {
    FairWarningBanner,
    LiveStatusChip,
    ResultOverlay,
  } from "./components/Status";

  import {
    AccessButton,
    AccessNotice,
    PlaceBidButton,
  } from "./components/BidControls";

  import BidHistory from "./components/BidHistory";
  import ImageRows from "./ImageRows";
  import { FONT, R } from "./components/roomTheme";

  /*
  * The artwork on the block (desktop and mobile), the catalogue details (desktop) and the
  * desktop bid control (next bid + Place Bid). The bid control is rendered into the bidding
  * panel on the right through a React portal (`bidSlot`), so it keeps using this
  * component's own state and incrementCount.
  *
  * BIDDING LOGIC IS UNCHANGED.
  */

  // Desktop / mobile video sources
  const VIDEO_SRC_DESKTOP =
    "https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&playback.latencyControlMode=balancedadaptive";

  const VIDEO_SRC_MOBILE =
    "https://demo.nanocosmos.de/nanoplayer/embed/1.3.3/nanoplayer.html?entry.rtmp.streamname=TKGUW-bCyQT&playback.latencyControlMode=balancedadaptive";

  // Main Component
  const Midlayout = ({
    socket,
    mediadQuery,
    room,
    titleAuction,
    details,
    toggleValue,
    setToggleValue,
    guest,
    status,
    bidSlot,
    artworkHeight,
  }) => {
    const isDesktop = mediadQuery !== false;
    const [sold, setSold] = useState("");
    const [getData, setGetData] = useState([]);
    const [image, setImage] = useState([]);

    // Selected image in the center artwork
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    const [auctionID, setAuctionID] = useState("");
    const [setID, setIDset] = useState("");
    const [lotNumber, setlotNumber] = useState("");
    const [bidhistory, setBidHistory] = useState([]);
    const [highestBid, setHighestBid] = useState(0);
    const [userId, setUserId] = useState("");
    const [highestNumber, setHighest] = useState("");
    const [group, setGroup] = useState("");
    const token = getToken();
    const [withdrawn, setWithdrawn] = useState(0);
    const [bidError, setBidError] = useState("");
    const navigate = useNavigate();
    const [mobileDetailsOpen, setMobileDetailsOpen] = useState(false);
    const [mobileLotsOpen, setMobileLotsOpen] = useState(false);
    const [vidSrc, setVidSrc] = useState("");
    const [vidIsvisible, setVidIsVisible] = useState(false);

    const handleClickOpen = async () => {
      const profileData = await getProfile();
      const profile = profileData.data[0];

      if (profile.paymongo_payment_method_id) {
        // Already has a payment method, proceed to join
        const joinResult = await JoinAuction(auctionID);

        if (joinResult.success === false) {
          alert(`Join auction failed: ${joinResult.msg}`);
        } else {
          alert(joinResult.msg);
          window.location.reload();
        }
      } else {
        navigate("/signup", {
          state: {
            userInfo: profile,
          },
        });
      }
    };

    // Result overlay for SOLD / UNSOLD / PASS / RESERVE NOT MET
    const getSoldOverlay = (status) => {
      const styles = {
        SOLD: {
          color: "#2E7D32",
          text: "SOLD",
        },
        UNSOLD: {
          color: "#C62828",
          text: "UNSOLD",
        },
        PASS: {
          color: "#00796B",
          text: "PASS",
        },
        RESERVE_NOT_MET: {
          color: "#F2C200",
          text: "RESERVE NOT MET",
        },
      };

      const item = styles[status];

      if (!item) return null;

      return (
        <ResultOverlay
          text={item.text}
          color={item.color}
        />
      );
    };

    const isProcessing = useRef(false);

    const incrementCount = async (
      auctionID,
      setID,
      lotNumber,
      highestBid
    ) => {
      if (isProcessing.current) return;

      isProcessing.current = true;

      try {
        const florrData = {
          auction_id: auctionID,
          setId: setID,
          lot_number: lotNumber,
          amount: highestBid,
        };

        const results = await postPlaceBid(florrData);

        const messageData = {
          room: room,
          status: results?.success,
          amount: highestBid,
          increment: highestBid,
        };

        if (results?.success === true) {
          setBidError("");

          socket.emit("send_status", {
            message: "OPEN",
          });

          socket.emit("send_Bid_amount", {
            messageData,
            florrData,
          });
        } else {
          const message =
            results?.msg ||
            "Invalid bid amount. Please try again.";

          setBidError(message);
        }
      } catch (err) {
        console.error("Bid error:", err);

        setBidError(
          "Unable to place the bid. Please try again."
        );
      } finally {
        isProcessing.current = false;
      }
    };

    const highestHammerRef = useRef(0);

    const currentLotNumberRef = useRef("");

    useEffect(() => {

      const initializeUser = async () => {
        try {
          const getuser = await getUser();

          setUserId(getuser.id);
          setGroup(getuser.group);
        } catch (error) {
          console.error(
            "User initialization failed:",
            error
          );
        }
      };

      initializeUser();

      // 1. Input Check
      if (!details || !details.lot?.details?.[0]) {
        console.log("No details to process.");
        return;
      }

      try {
        const lotDetails =
          details.lot.details[0];

        const auctionDetails =
          details.auction_details;

        const newBidHistory =
          details.bid_history || [];

        const newLotNumber =
          lotDetails.lot_number || "";

        setBidHistory(newBidHistory);

        // 2. Calculate New Highest Hammer
        const newHighestHammer =
          newBidHistory.length
            ? Math.max(
                ...newBidHistory.map(
                  (o) => o.hammer
                )
              )
            : 0;

        // 3. Conditional Update Logic
        let shouldUpdate = false;

        // Scenario A: New Lot
        if (
          newLotNumber !==
          currentLotNumberRef.current
        ) {
          shouldUpdate = true;

          console.log(
            `Switching Lot from ${currentLotNumberRef.current} to ${newLotNumber}.`
          );
        }

        // Scenario B: New highest bid
        else if (
          newHighestHammer >
          highestHammerRef.current
        ) {
          shouldUpdate = true;

          console.log(
            `New Highest Bid: ${newHighestHammer}.`
          );
        }

        // Scenario C: Duplicate
        else {
          if (
            newHighestHammer ===
              highestHammerRef.current &&
            newLotNumber ===
              currentLotNumberRef.current
          ) {
            console.log(
              "Details received, but lot/hammer is the same. Skipping state update."
            );

            return;
          }
        }

        if (shouldUpdate) {
          // 4. State Updates

          setSold("");

          setGetData(
            details.lot.details || []
          );

          setlotNumber(newLotNumber);

          setImage(
            details.lot.image_lot || []
          );

          // Reset thumbnail to first image
          setSelectedImageIndex(0);

          setIDset(
            auctionDetails?.id || ""
          );

          setAuctionID(
            auctionDetails?.auction_id || ""
          );

          setWithdrawn(
            lotDetails.isWithdrawn || false
          );

          setBidError("");

          const price = lotDetails?.hp
            ? details.increment
            : lotDetails?.starting_price;

          setHighest(newHighestHammer);

          setHighestBid(price || 0);

          setBidHistory(newBidHistory);
   
         
          // 5. UPDATE REFS
          highestHammerRef.current =
            newHighestHammer;

          currentLotNumberRef.current =
            newLotNumber;
        }
      } catch (error) {
        console.error(
          "Data processing failed:",
          error
        );
      }
    }, [socket, details]);


    
      useEffect(() => {
        const livestream = details?.livestream?.[0];

        const visible =
          livestream?.is_visible === true ||
          livestream?.is_visible === 1 ||
          livestream?.is_visible === "1";

        setVidSrc(livestream?.base_url || "");
        setVidIsVisible(visible);
        console.log(livestream, "livestream");
      }, [details]);


    useEffect(() => {
      const initialStatus =
        details?.lot?.details?.[0]
          ?.lot_status;

      const currentStatus =
        status || initialStatus;

      console.log(
        "Current active status:",
        currentStatus
      );

      if (
        [
          "SOLD",
          "UNSOLD",
          "PASS",
          "RESERVE_NOT_MET",
        ].includes(currentStatus)
      ) {
        setSold(
          getSoldOverlay(currentStatus)
        );
      } else {
        setSold("");
      }
    }, [status, details]);

    const highestNumberBidder =
      details.bid_history.length > 0
        ? Math.max(
            ...details.bid_history.map(
              (bid) => bid.hammer
            )
          )
        : "₱ 0";

    useEffect(() => {
      const handleFloorUpdate = (data) => {
        setHighestBid(
          data.floorValue
        );
      };

      socket.on(
        "receiveFloorValue",
        handleFloorUpdate
      );

      return () => {
        socket.off(
          "receiveFloorValue",
          handleFloorUpdate
        );
      };
    }, [socket]);

    const handleClose1 = () => {
      setToggleValue(false);
    };

    const loginTobid = () => {
      window.location.href = "/login";
    };

    const activeStatus =
      status && status !== ""
        ? status
        : details?.lot?.details?.[0]
            ?.lot_status;

    const isFairWarning =
      activeStatus === "FAIR_WARNING";

    /*
    * Determine if thumbnail gallery should be shown.
    *
    * More than one image = show thumbnails.
    * One image / no image = use full artwork height.
    */
    const hasThumbnails =
      image.length > 1 &&
      withdrawn !== 1;

    /*
    * Reduce the artwork height only when
    * thumbnails actually exist.
    *
    * Desktop:
    * reserve 86px for thumbnails.
    *
    * Mobile:
    * reserve 74px for thumbnails.
    */
    const mainArtworkHeight = hasThumbnails
      ? Math.max(
          Number(artworkHeight) -
            (mediadQuery !== false
              ? 86
              : 74),
          mediadQuery !== false
            ? 250
            : 220
        )
      : artworkHeight;

    /*
    * Main image.
    *
    * If withdrawn:
    * show withdrawn image.
    *
    * Otherwise:
    * show selected thumbnail image.
    */
    const imageSrc = image.length
      ? withdrawn === 1
        ? WITHDRAWN_IMAGE
        : image[selectedImageIndex]
            ?.img_url ||
          image[0]?.img_url
      : NoImage;

    // Same rule as before
    // for highest bidder
    const isHighestBidder =
      bidhistory.filter(
        (val) =>
          val.userId === userId &&
          val.win_status === "WIN" &&
          val.hammer === highestNumber
      ).length;

    const bidDisabled =
      withdrawn === 1
        ? true
        : isHighestBidder ||
          status === "PENDING" ||
          status === "PAUSE" ||
          status === "UNSOLD" ||
          status === "SOLD"
        ? group === "ADMIN"
          ? false
          : true
        : false;

    const placeBidButton = (
      <PlaceBidButton
        disabled={bidDisabled}
        winning={Boolean(
          isHighestBidder
        )}
        onClick={(e) =>
          incrementCount(
            auctionID,
            setID,
            lotNumber,
            highestBid
          )
        }
        primary={
          "₱ " +
          (highestBid !== null
            ? highestBid.toLocaleString()
            : 0)
        }
        secondary={
          isHighestBidder
            ? "highest bidder"
            : "Place bid"
        }
      />
    );

    // Who may bid
    const bidAction =
      token === null ? (
        <AccessButton onClick={loginTobid}>
          Login to bid
        </AccessButton>
      ) : group === "ADMIN" ? (
        placeBidButton
      ) : guest === "pending" ||
        guest === "Not approved" ? (
        <AccessNotice kind="pending" />
      ) : guest === "declined" ? (
        <AccessNotice kind="declined" />
      ) : guest === 0 ? (
        <AccessButton
          onClick={handleClickOpen}
        >
          Join room request
        </AccessButton>
      ) : guest === "approved" ? (
        placeBidButton
      ) : null;

    const desktopBidControl = (
      <Box sx={{ pt: 1.25, width: "100%" }}>
        {bidError && (
          <Box role="alert" sx={{ mb: 1, px: 1.25, py: 0.75, borderLeft: `3px solid ${R.danger}`, bgcolor: R.dangerBg, color: R.danger, fontFamily: FONT, fontSize: "0.75rem", lineHeight: 1.35 }}>
            {bidError}
          </Box>
        )}
        <Box sx={{ width: "100%", "& > *": { width: "100%", maxWidth: "none" } }}>
          {bidAction}
        </Box>
      </Box>
    );

    const currentLotDetails = getData?.[0] || details?.lot?.details?.[0] || {};
    const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== "" && String(value).trim() !== "-" && String(value).trim() !== "—";
    const cleanText = (value) => String(value ?? "").replace(/<br\s*\/?>(?!\n)/gi, "\n").replace(/<[^>]*>/g, "").trim();
    const detailValue = (...keys) => {
      for (const key of keys) {
        if (hasValue(currentLotDetails?.[key])) return currentLotDetails[key];
      }
      return null;
    };
    const lotValue = currentLotDetails?.lot_number;
    const artistValue = detailValue("artist_name", "artist", "artistName");
    const titleValue = detailValue("title", "lot_title", "lotTitle");
    const detailRows = [
      ["Size", detailValue("size")],
      ["Signed and Dated", detailValue("signed_dated", "signed_date", "signed_and_dated", "signedDate")],
      ["Medium", detailValue("medium")],
      ["COA", detailValue("coa", "certificate_of_authenticity", "certificateOfAuthenticity")],
      ["Property", detailValue("property")],
      ["Exhibited", detailValue("exhibited", "exhibit", "exhibition")],
      ["Writeup", detailValue("write_up", "writeup", "write-up")],
    ].filter(([, value]) => hasValue(value));
    const headingName = hasValue(artistValue) ? artistValue : titleValue;
    const showTitleBelow = hasValue(artistValue) && hasValue(titleValue);

    return (
      <Box
        component="section"
        aria-label="Lot on the block"
        sx={{
          fontFamily: FONT,
          width: "100%",
          height: isDesktop ? "100%" : "auto",
          minHeight: 0,
          overflow: isDesktop ? "hidden" : "visible",
        }}
      >
        {!isDesktop ? (
          <Box
            sx={{
              width: "100%",
              height: "auto",
              minHeight: 0,
              display: "grid",
              gridTemplateRows: toggleValue === true
              ? "auto auto"
              : "minmax(clamp(300px, 48svh, 520px), auto) auto",
              overflow: "visible",
            }}
          >
            {/* MOBILE ROW 1 — MEDIA */}
            <Box
              sx={{
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  px: 1.5,
                  py: 0.65,
                  bgcolor: R.paper,
                  borderBottom: `1px solid ${R.line}`,
                }}
              >
                <LiveStatusChip status={activeStatus} sx={{ flexShrink: 0 }} />
                <Typography
                  sx={{
                    minWidth: 0,
                    flex: 1,
                    textAlign: "right",
                    fontFamily: FONT,
                    fontSize: "0.68rem",
                    color: R.secondary,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {titleAuction || ""}
                </Typography>
              </Box>

              <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
                <FairWarningBanner show={isFairWarning} inline />
                <ArtworkStage
                  src={imageSrc}
                  alt={
                    getData[0]
                      ? `Lot ${getData[0].lot_number}`
                      : "Current lot"
                  }
                  height="100%"
                  videoOpen={toggleValue === true}
                  videoSrc={vidSrc}
                  onCloseVideo={handleClose1}
                  centerVideo
                  videoVisible={vidIsvisible}

                />
                {sold}
              </Box>

              {hasThumbnails && (
                <Box
                  sx={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.75,
                    px: 1,
                    py: 0.5,
                    overflowX: "auto",
                    overflowY: "hidden",
                    bgcolor: R.paper,
                    borderTop: `1px solid ${R.line}`,
                    scrollbarWidth: "thin",
                    "&::-webkit-scrollbar": { height: 4 },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#b5b5b5",
                      borderRadius: 4,
                    },
                  }}
                >
                  {image.map((img, index) => {
                    const isSelected = selectedImageIndex === index;
                    return (
                      <Box
                        key={img.id || img.img_url || index}
                        component="button"
                        type="button"
                        onClick={() => setSelectedImageIndex(index)}
                        aria-label={`View lot image ${index + 1}`}
                        sx={{
                          width: 50,
                          height: 50,
                          p: 0,
                          flex: "0 0 auto",
                          cursor: "pointer",
                          backgroundColor: "#fff",
                          border: isSelected
                            ? `2px solid ${R.ink}`
                            : `1px solid ${R.line}`,
                          borderRadius: 0,
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          component="img"
                          src={img.img_url}
                          alt={`Lot image ${index + 1}`}
                          sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>

            {/* MOBILE ROW 2 — LOT SUMMARY + VIDEO / LOTS */}
            <Box
              sx={{
                flexShrink: 0,
                display: "grid",
                gridTemplateColumns: "minmax(0, 3fr) minmax(88px, 1fr)",
                gap: 0.75,
                p: 1,
                bgcolor: R.paper,
                borderTop: `1px solid ${R.lineStrong}`,
                minHeight: 92,
              }}
            >
              <Box
                component="button"
                type="button"
                onClick={() => setMobileDetailsOpen(true)}
                aria-label="Open lot details and bid history"
                sx={{
                  minWidth: 0,
                  textAlign: "left",
                  p: 1,
                  border: "none",
                  bgcolor: R.paper,
                  color: R.ink,
                  cursor: "pointer",
                  fontFamily: FONT,
                  "&:active": { bgcolor: R.soft },
                }}
              >
                {(hasValue(lotValue) || hasValue(headingName)) && (
                  <>
                    <Typography
                      component="h3"
                      sx={{
                        m: 0,
                        fontFamily: FONT,
                        fontSize: "0.88rem",
                        fontWeight: 700,
                        lineHeight: 1.25,
                        color: R.ink,
                      }}
                    >
                      {hasValue(lotValue) ? `LOT ${lotValue}` : "LOT"}
                      {hasValue(headingName)
                        ? ` | ${cleanText(headingName)}`
                        : ""}
                    </Typography>

                    {showTitleBelow && (
                      <Typography
                        component="div"
                        sx={{
                          mt: 0.25,
                          fontFamily: FONT,
                          fontSize: "0.76rem",
                          fontStyle: "italic",
                          lineHeight: 1.3,
                          color: R.text,
                        }}
                      >
                        {cleanText(titleValue)}
                      </Typography>
                    )}
                  </>
                )}

                <Typography
                  sx={{
                    mt: 0.65,
                    fontFamily: FONT,
                    fontSize: "0.6rem",
                    fontWeight: 700,
                    letterSpacing: "0.55px",
                    textTransform: "uppercase",
                    color: R.secondary,
                  }}
                >
                  More Details & Bid History
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 0.65,
                  minWidth: 0,
                }}
              >
                <IconButton
                  type="button"
                  onClick={() => setToggleValue((prev) => !prev)}
                  aria-label={toggleValue === true ? "Close video" : "Watch video"}
                  title={toggleValue === true ? "Close video" : "Watch video"}
                  sx={{
                    width: 40,
                    height: 40,
                    alignSelf: "flex-end",
                    borderRadius: 0,
                    color: toggleValue === true ? R.ink : R.danger,
                    border: `1px solid ${R.line}`,
                  }}
                >
                  <PlayCircleOutlineIcon />
                </IconButton>

                <IconButton
                  type="button"
                  onClick={() => setMobileLotsOpen(true)}
                  aria-label="View lots"
                  title="View lots"
                  sx={{
                    width: 40,
                    height: 40,
                    alignSelf: "flex-end",
                    borderRadius: 0,
                    color: R.ink,
                    border: `1px solid ${R.line}`,
                  }}
                >
                  <FormatListBulletedIcon />
                </IconButton>
              </Box>
            </Box>

            {/* MOBILE LOT DETAILS + BID HISTORY MODAL */}
            <Dialog
              fullScreen
              open={mobileDetailsOpen}
              onClose={() => setMobileDetailsOpen(false)}
            >
              <DialogTitle
                sx={{
                  fontFamily: FONT,
                  fontWeight: 700,
                  borderBottom: `1px solid ${R.line}`,
                  pr: 6,
                }}
              >
                Lot Details & Bid History
                <IconButton
                  onClick={() => setMobileDetailsOpen(false)}
                  aria-label="Close"
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
                {(hasValue(lotValue) || hasValue(headingName)) && (
                  <Box sx={{ mb: 1.5 }}>
                    <Typography
                      component="h3"
                      sx={{
                        m: 0,
                        fontFamily: FONT,
                        fontWeight: 700,
                        fontSize: "1.1rem",
                        color: R.ink,
                      }}
                    >
                      {hasValue(lotValue) ? `LOT ${lotValue}` : "LOT"}
                      {hasValue(headingName)
                        ? ` | ${cleanText(headingName)}`
                        : ""}
                    </Typography>

                    {showTitleBelow && (
                      <Typography
                        sx={{
                          mt: 0.35,
                          fontFamily: FONT,
                          fontSize: "0.95rem",
                          fontStyle: "italic",
                          color: R.text,
                        }}
                      >
                        {cleanText(titleValue)}
                      </Typography>
                    )}
                  </Box>
                )}

                {detailRows.map(([label, value]) => (
                  <Box
                    key={label}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "120px minmax(0,1fr)",
                      gap: 1,
                      py: 0.85,
                      borderBottom: `1px solid ${R.line}`,
                    }}
                  >
                    <Typography
                      component="h4"
                      sx={{
                        m: 0,
                        fontFamily: FONT,
                        fontSize: "0.66rem",
                        fontWeight: 700,
                        letterSpacing: "0.65px",
                        textTransform: "uppercase",
                        color: R.secondary,
                      }}
                    >
                      {label}
                    </Typography>

                    <Typography
                      sx={{
                        m: 0,
                        fontFamily: FONT,
                        fontSize: "0.88rem",
                        lineHeight: 1.5,
                        color: R.ink,
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      {cleanText(value)}
                    </Typography>
                  </Box>
                ))}

                <Box sx={{ mt: 2 }}>
                  <Typography
                    component="h4"
                    sx={{
                      m: 0,
                      mb: 0.75,
                      fontFamily: FONT,
                      fontSize: "0.7rem",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      color: R.secondary,
                    }}
                  >
                    Bid History
                  </Typography>

                  <BidHistory
                    bidhistory={bidhistory}
                    userId={userId}
                    highestNumber={highestNumber}
                    status={status}
                    group={group}
                    fill
                  />
                </Box>
              </DialogContent>
            </Dialog>

            {/* MOBILE AUCTION LOTS MODAL */}
            <Dialog
              fullScreen
              open={mobileLotsOpen}
              onClose={() => setMobileLotsOpen(false)}
            >
              <DialogTitle
                sx={{
                  fontFamily: FONT,
                  fontWeight: 700,
                  borderBottom: `1px solid ${R.line}`,
                  pr: 6,
                }}
              >
                Auction Lots
                <IconButton
                  onClick={() => setMobileLotsOpen(false)}
                  aria-label="Close"
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent sx={{ p: 0 }}>
                <ImageRows
                  open={false}
                  details={details}
                  mediadQuery={mediadQuery}
                  lotNumberNo={lotNumber}
                  fullList
                />
              </DialogContent>
            </Dialog>
          </Box>
        ) : (
          <Box sx={{ display: "grid", gridTemplateRows: "minmax(0, 3fr) minmax(0, 1fr)", height: "100%", minHeight: 0, gap: 1 }}>
            <Box sx={{ minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden", position: "relative" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flexShrink: 0, minHeight: 36, px: 0.5, pb: 0.75 }}>
                <LiveStatusChip status={activeStatus} />
              </Box>
              <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
                <FairWarningBanner show={isFairWarning} />
                <ArtworkStage src={imageSrc} alt={getData[0] ? `Lot ${getData[0].lot_number}` : "Current lot"} height="100%" videoOpen={toggleValue === true} videoSrc={vidSrc} onCloseVideo={undefined}   videoVisible={vidIsvisible}>
                  {sold}
                </ArtworkStage>
              </Box>
              {hasThumbnails && (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, flexShrink: 0, mt: 0.75, px: 1, pb: 0.25, overflowX: "auto", overflowY: "hidden", scrollbarWidth: "thin", "&::-webkit-scrollbar": { height: 4 }, "&::-webkit-scrollbar-thumb": { backgroundColor: "#b5b5b5", borderRadius: 4 } }}>
                  {image.map((img, index) => {
                    const isSelected = selectedImageIndex === index;
                    return (
                      <Box key={img.id || img.img_url || index} component="button" type="button" onClick={() => setSelectedImageIndex(index)} aria-label={`View lot image ${index + 1}`} sx={{ width: 64, height: 64, p: 0, flex: "0 0 auto", cursor: "pointer", backgroundColor: "#fff", border: isSelected ? `2px solid ${R.ink}` : `1px solid ${R.line}`, borderRadius: 0, overflow: "hidden" }}>
                        <Box component="img" src={img.img_url} alt={`Lot image ${index + 1}`} sx={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} />
                      </Box>
                    );
                  })}
                </Box>
              )}
            </Box>

            <Box component="section" aria-label="Lot details" sx={{ minHeight: 0, overflowY: "auto", overflowX: "hidden", px: { md: 1, lg: 1.5 }, pb: 1, scrollbarWidth: "thin", "&::-webkit-scrollbar": { width: 5 }, "&::-webkit-scrollbar-thumb": { backgroundColor: R.lineStrong, borderRadius: 5 } }}>
              {(hasValue(lotValue) || hasValue(headingName)) && (
                <Box sx={{ mb: showTitleBelow ? 0.5 : 0.75 }}>
                  <Typography component="h4" sx={{ m: 0, fontFamily: FONT, fontSize: { md: "1rem", lg: "1.12rem" }, fontWeight: 700, color: R.ink, lineHeight: 1.25 }}>
                    {hasValue(lotValue) ? `LOT ${lotValue}` : "LOT"}{hasValue(headingName) ? ` | ${cleanText(headingName)}` : ""}
                  </Typography>
                  {showTitleBelow && <Typography component="div" sx={{ mt: 0.25, fontFamily: FONT, fontSize: { md: "0.92rem", lg: "1rem" }, fontStyle: "italic", color: R.text, lineHeight: 1.3 }}>{cleanText(titleValue)}</Typography>}
                </Box>
              )}
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {detailRows.map(([label, value]) => (
                  <Box key={label} sx={{ display: "grid", gridTemplateColumns: "125px minmax(0, 1fr)", columnGap: 1.25, alignItems: "start", py: 0.5 }}>
                    <Typography component="h4" sx={{ m: 0, fontFamily: FONT, fontSize: "0.65rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.7px", color: R.secondary }}>{label}</Typography>
                    <Typography component="div" sx={{ fontFamily: FONT, fontSize: "0.78rem", color: R.ink, lineHeight: 1.45, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{cleanText(value)}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        )}

        {isDesktop && bidSlot ? createPortal(desktopBidControl, bidSlot) : null}
      </Box>
    );
  };

  export default Midlayout;